module.exports = __webpack_public_path__ + "img/6_71.95423f2c.png";